
export default {
  name: 'AppTransitionGroupExpand',
  props: {
    items: { type: Array, required: true }
  },
  methods: {
    enter(element) {
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = getComputedStyle(element).height;

      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      element.style.height = height;
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      element.style.display = 'none';
    }
  }
};
